import { render } from "./ElectricityPriceList.vue?vue&type=template&id=2e0542eb&scoped=true"
import script from "./ElectricityPriceList.vue?vue&type=script&lang=js"
export * from "./ElectricityPriceList.vue?vue&type=script&lang=js"

import "./ElectricityPriceList.vue?vue&type=style&index=0&id=2e0542eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0542eb"]])

export default __exports__